module.exports = __webpack_public_path__ + "img/search-icon.011bde07.svg";